angular.module('tasks')
    .service('TaskAuditService', function ($http, modals) {
        this.auditTable = params => $http.get('/crm/api/task/audit/table', {params: params}).then(res => res.data);
        this.auditLogDetails = item => modals.open('app/utils/audit-data-info/audit-history-log-modal.html', 'AuditHistoryLogsDialogController', {
            resourceType: 'TASK',
            resourceId: item.resourceId
        }, {size: 'lg'}, "$ctrl");
    })
    .config(function ($stateProvider) {
        $stateProvider.state('taskAuditLogs', {
            parent: 'app',
            url: '/task-logs?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{resourceId:int}&action&{userId:int}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_TASKS_SUPERUSER']
            },
            views: {
                'content@': 'taskAuditLogsList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (TaskAuditService, $stateParams) => TaskAuditService.auditTable(angular.copy($stateParams))
            }
        });
    });
